import { createAsyncThunk } from "@reduxjs/toolkit";

export const liquidGetCart = createAsyncThunk(
  'cart/liquidGetCart',
  async (info, { getState }) => {
    const { elements: { liquid, cartId } } = getState()
    return await liquid.cart({ id: cartId })
  }
)
